Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _useBox2 = require("./useBox");
var _useColors2 = require("./useColors");
var _useParagraphStyles2 = require("./useParagraphStyles");
var _useBreakpoints2 = require("./useBreakpoints");
var _useFocused2 = require("./useFocused");
var _useSpacing2 = require("./useSpacing");
var _useInput2 = require("./useInput");
var _useDisabled2 = require("./useDisabled");
var _useSizing2 = require("./useSizing");
var _useFont = require("./useFont");
var _useBoxShadows2 = require("./useBoxShadows");
var _useContainer2 = require("./useContainer");
var _FontSize = require("../FontSize");
var _Grid = require("../Grid");
var useStyles = exports.useStyles = function useStyles() {
  var _useBox = (0, _useBox2.useBox)(),
    box = _useBox.box;
  var _useColors = (0, _useColors2.useColors)(),
    colors = _useColors.colors,
    COLORS = _useColors.COLORS,
    improvementColors = _useColors.improvementColors;
  var _useParagraphStyles = (0, _useParagraphStyles2.useParagraphStyles)(),
    paragraph = _useParagraphStyles.paragraph;
  var _useBreakpoints = (0, _useBreakpoints2.useBreakpoints)(),
    bp = _useBreakpoints.bp,
    viewports = _useBreakpoints.viewports;
  var _useFocused = (0, _useFocused2.useFocused)(),
    focused = _useFocused.focused;
  var _useSpacing = (0, _useSpacing2.useSpacing)(),
    spacing = _useSpacing.spacing;
  var _useInput = (0, _useInput2.useInput)(),
    input = _useInput.input,
    input_base = _useInput.input_base;
  var _useDisabled = (0, _useDisabled2.useDisabled)(),
    disabled = _useDisabled.disabled;
  var _useSizing = (0, _useSizing2.useSizing)(),
    sizing = _useSizing.sizing;
  var fonts = (0, _useFont.useFont)();
  var _useBoxShadows = (0, _useBoxShadows2.useBoxShadows)(),
    boxShadows = _useBoxShadows.boxShadows,
    boxShadowsRaw = _useBoxShadows.boxShadowsRaw;
  var _useContainer = (0, _useContainer2.useContainer)(),
    container = _useContainer.container,
    container_noHeader = _useContainer.container_noHeader;
  return Object.assign({}, fonts, {
    box: box,
    colors: colors,
    COLORS: COLORS,
    improvementColors: improvementColors,
    paragraph: paragraph,
    bp: bp,
    viewports: viewports,
    focused: focused,
    spacing: spacing,
    input: input,
    input_base: input_base,
    disabled: disabled,
    sizing: sizing,
    boxShadows: boxShadows,
    boxShadowsRaw: boxShadowsRaw,
    fontSize: _FontSize.fontSize,
    lineHeight: _FontSize.lineHeight,
    grid: _Grid.grid,
    container: container,
    container_noHeader: container_noHeader
  });
};